import { Form, Formik } from "formik";
import { FormikInput } from "@/components/common/form/FormikInput.tsx";
import { Button } from "@/components/base/Button.tsx";
import { useStore } from "@/stores/useStore.ts";
import { Error } from "@/components/base/Error.tsx";

export const LoginForm = () => {
  const login = useStore((s) => s.login);
  const authError = useStore((s) => s.authError);
  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      onSubmit={(values) => login(values.email, values.password)}
    >
      <Form className="flex flex-col gap-4 m-auto sm:w-64">
        <FormikInput name="email" id="email" label="E-mail" type="email" />
        <FormikInput
          name="password"
          id="password"
          label="Password"
          type="password"
        />
        {authError && <Error error={authError} />}
        <Button type="submit">Submit</Button>
      </Form>
    </Formik>
  );
};
